import { render } from "./FluidsdataInsight.vue?vue&type=template&id=3311068f"
import script from "./FluidsdataInsight.vue?vue&type=script&lang=js"
export * from "./FluidsdataInsight.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__